import { toggle } from "@otto-ec/global-resources/toggle"
import { isOnexVariant } from "@otto-ec/global-resources/onex"
import { startRefreshByOrt } from "./refreshByOrt"
import { refreshByOwt } from "./refreshByOwt"
import { onLoad } from "@otto-ec/global-resources/dom"

export async function initRefresh() {
    if (toggle.get("fti_enable_session_refresh_by_ort") || isOnexVariant("E3698", "E3698B")) {
        await startRefreshByOrt()
    } else {
        await refreshByOwt()
    }
}
onLoad.subscribe(initRefresh)
